const workProjects = [
  {
    id: 'grenville',
    categoryEn: 'EV Charging Installation',
    categoryZh: 'EV充電設備安裝',
    titleEn: 'EV Chargers - GrenVille',
    titleZh: '電動車充電器 - 嘉慧園',
    info: {
      clientEn: 'Duosida Hong Kong Limited', clientZh: '多思達香港有限公司',
      locationEn: '1 Magazine Gap Rd, Mid-Levels', locationZh: '香港半山馬己仙峽道1號',
    },
    features: [
      { en: 'Installation of Five AC Chargers', zh: '安裝5台AC電動車充電器' },
      { en: 'Digital Payment System (Kiosk)', zh: '安裝自動收費機' },
      { en: 'Octopus System', zh: '包括八達通付款機' },
      { en: 'Management System', zh: '後台中央管理系統' },
    ],
    images: [
      { src: '/assets/works/grenville1.jpg', alt: 'GrenVille EV Charger 1' },
      { src: '/assets/works/grenville2.jpg', alt: 'GrenVille EV Charger 2' },
    ],
  },
  {
    id: 'byd',
    categoryEn: 'EV Charging Installation',
    categoryZh: 'EV充電設備安裝',
    titleEn: 'BYD Taxi Charging Stations',
    titleZh: '比亞迪出租車充電站',
    info: {
      clientEn: 'SmartPro Charging Limited', clientZh: '智絡充電有限公司',
      locationEn: '45-51 Tai Lin Pai Road, Kwai Chung', locationZh: '新界葵涌大連排道45-51號',
    },
    features: [
      { en: 'Digital Payment System (Kiosk)', zh: '自動收費系統' },
      { en: 'Management System', zh: '後台中央管理系統' },
      { en: 'Apps', zh: '手機應用程式' },
      { en: 'EV Chargers and Software Matching', zh: 'EV充電機及軟件配對' },
      { en: 'Car Plate Recognition System', zh: '車牌辨認系統' },
    ],
    images: [
      { src: '/assets/works/smartpro1.jpg', alt: 'BYD Taxi Charging Station 1' },
      { src: '/assets/works/smartpro2.jpg', alt: 'BYD Taxi Charging Station 2' },
    ],
  },
  {
    id: 'fortuna',
    categoryEn: 'EV Charging Installation',
    categoryZh: 'EV充電設備安裝',
    titleEn: 'EV Chargers - Fortuna Court (23 Charging Stations)',
    titleZh: '電動車充電器 - 富澤苑（23個充電站）',
    info: {
      clientEn: 'Fortuna Court', clientZh: '富澤苑',
      locationEn: '25 Repulse Bay Road, Repulse Bay', locationZh: '淺水灣道25號',
    },
    features: [
      { en: 'Digital Payment System (Kiosk)', zh: '自動收費系統' },
      { en: 'Management System', zh: '中央管理系統' },
      { en: 'Apps', zh: '手機應用程式' },
      { en: 'EV Chargers and Software Matching', zh: 'EV充電機及軟件配對' },
    ],
    images: [
      { src: '/assets/works/fortuna1.png', alt: 'Fortuna House Charging Station 1' },
      { src: '/assets/works/fortuna2.jpg', alt: 'Fortuna House Charging Station 2' },
    ],
  },
  {
    id: 'leungking',
    categoryEn: 'EV Charging Installation',
    categoryZh: 'EV充電設備安裝',
    titleEn: 'EV Chargers - Leung King Estate (120kW DC Charger)',
    titleZh: '電動車充電器 - 良景邨（120kW DC充電器）',
    info: {
      clientEn: 'Kong Shum Smart Management Group (Holdings) Limited', clientZh: '港深智能管理集團（控股）有限公司',
      locationEn: '31 Tin King Road, Tuen Mun', locationZh: '新界屯門田景路31號',
    },
    features: [
      { en: 'Digital Payment System (Kiosk)', zh: '自動收費系統' },
      { en: 'Management System', zh: '中央管理系統' },
      { en: 'Apps', zh: '手機應用程式' },
      { en: 'EV Chargers and Software Matching', zh: 'EV充電機及軟件配對' },
    ],
    images: [
      { src: '/assets/works/leungking1.jpg', alt: 'Leung King Estate DC Charger 1' },
      { src: '/assets/works/leungking2.jpg', alt: 'Leung King Estate DC Charger 2' },
    ],
  },
  {
    id: 'kings',
    categoryEn: 'EV Charging Installation',
    categoryZh: 'EV充電設備安裝',
    titleEn: 'EV Chargers - 83 King Lam Street (DC Charger)',
    titleZh: '電動車充電器 - 83京蘭街（DC充電器）',
    info: {
      clientEn: "King's Limousine Company Limited", clientZh: '京時豪華汽車有限公司',
      locationEn: '83 King Lam Street', locationZh: '83號 King Lam St',
    },
    features: [
      { en: 'Management System', zh: '中央管理系統' },
      { en: 'EV Chargers and Software Matching', zh: 'EV充電機及軟件配對' },
    ],
    images: [
      { src: '/assets/works/kings2.jpg', alt: 'King Lam Street DC Charger 1' },
      { src: '/assets/works/kings3.jpg', alt: 'King Lam Street DC Charger 2' },
    ],
  },
  {
    id: 'sem',
    categoryEn: 'Smart Management',
    categoryZh: '智慧管理系統',
    titleEn: 'Smart Estate Management (SEM)',
    titleZh: '智慧屋苑管理系統（SEM）',
    info: {
      clientEn: 'Kong Shum Smart Management Group (Holdings) Limited', clientZh: '港深智能管理集團（控股）有限公司',
      locationEn: '31 Tin King Road, Tuen Mun', locationZh: '新界屯門田景路31號',
    },
    features: [],
    images: [
      { src: '/assets/works/sem.png', alt: 'Smart Estate Management System' },
      { src: '/assets/works/fee1.jpg', alt: 'Smart Estate Management Fee System' },
    ],
  },
];

export default workProjects;
